import { isJust } from "./maybe";
import { entityTypeLabel } from "./entityFrontmatter";
import type { DatabaseEntrySummary } from "./tauri/database";

/** Shared worldbuilding groups for the timeline tray and scene link picker. */
export function groupSceneLinkEntries(
  entries: DatabaseEntrySummary[],
): [string, DatabaseEntrySummary[]][] {
  const groups = new Map<string, DatabaseEntrySummary[]>();
  for (const entry of entries) {
    if (entry.isMap) continue;
    const label = entityTypeLabel(entry.fields.type);
    const key = isJust(label) ? label.value : "Other";
    groups.set(key, [...(groups.get(key) ?? []), entry]);
  }
  return [...groups].sort(([a], [b]) => a.localeCompare(b));
}
